export default "__VITE_ASSET__C8K9OA09__"